// 技术生态-核心技术
<template>
  <div class="ecological-coreTechnology">
    <div class="info">
      <img :src="ecological_coreTechnology_icon" alt="认知智能引擎" />
      <div class="title">核心技术</div>
    </div>
    <div class="info-ul">
      <!-- <div class="info-ul-title">主要核心优势</div> -->
      <div class="info-li" v-for="item in advantage" :key="item">
        {{ item }}
      </div>
    </div>
    <CoreTechnologyItem />
  </div>
</template>
<script>
import ecological_coreTechnology_icon from "@/../static/img/ecological/ecological_coreTechnology_icon.png";
import CoreTechnologyItem from "./coreTechnologyItem.vue";
export default {
  name: "ecological-coreTechnology",
  components: { CoreTechnologyItem },
  data() {
    return {
      ecological_coreTechnology_icon,
      advantage: []
    };
  }
};
</script>
<style lang="less" scoped>
.ecological-coreTechnology {
  width: 100%;
  padding: 96px 0px;
  background: #ffffff;
  .info {
    width: 100%;
    height: 384px;
    background: url("../../../../static/img/ecological/ecological_coreTechnology_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 44px;
      color: #08204d;
      line-height: 60px;
      height: 60px;
      margin-top: 0;
      font-weight: 500;
    }
    > img {
      width: 240px;
      height: 240px;
      margin-top: 26px;
      margin-bottom: 0;
    }
  }
  .info-ul {
    padding-top: 2px;
    padding-bottom: 80px;
    background: url("../../../../static/img/ecological/info-ul-bg.png")
      no-repeat 0 0 / 100%;
    .info-ul-title {
      height: 36px;
      font-size: 26px;
      font-weight: 700;
      color: #08204d;
      line-height: 36px;
      text-align: center;
      margin-bottom: 20px;
    }
    .info-li {
      display: flex;
      box-sizing: border-box;
      padding: 0 64px;
      font-size: 24px;
      min-height: 40px;
      line-height: 40px;
      margin: 5px 0;
      color: #08204d;
      .round {
        min-width: 12px;
        min-height: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #a2b1cf;
        margin-right: 16px;
        margin-top: 14px;
      }
    }
  }
  .plans {
    height: 820px;
    overflow: hidden;
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .plan-box {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      .plan-item {
        width: 240px;
        margin-bottom: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;
        > img {
          width: 180px;
          height: 180px;
        }
        .text {
          margin-top: 8px;
          font-size: 32px;
          color: #08204d;
          line-height: 44px;
        }
        .desc {
          font-size: 24px;
          color: #97a2b5;
          line-height: 52px;
        }
      }
    }
  }
  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }
    .desc {
      margin-top: 8px;
      font-size: 24px;
      color: #97a2b5;
      line-height: 52px;
      text-align: center;
    }
    .product-catgory {
      margin-top: 32px;
      .product-catgory-item {
        .product-catgory-item-title {
          width: 100%;
          height: 200px;
          line-height: 200px;
          font-size: 32px;
          color: #08204d;
          text-align: center;
        }
        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }
        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }
  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px;
    }
  }
  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ecological/coreTechnology/index.vue